import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { CheckCircle, ExternalLink } from "react-feather";
import {
  getBrandById as getBrandByIdAction,
  getRetailerById as getRetailerByIdAction,
} from "../ReduxToolkit/Reducers/brands";
import { getCamelCaseWord } from "../static/brands_wholesalers_data";

// Shown after a manual add when the AI says some profiles already exist. It only sends their ids,
// so the names are looked up here; a failed lookup still leaves the link, which only needs the id.
const ExistingProfilesModal = ({ type, open, ids, createdCount, onClose, getBrandById, getRetailerById }) => {
  const [profiles, setProfiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const label = getCamelCaseWord(type);
  const count = (n) => `${n} ${type}${n === 1 ? "" : "s"}`;

  useEffect(() => {
    if (!ids.length) return;
    const load = async () => {
      setIsLoading(true);
      const getById = type === "brand" ? getBrandById : getRetailerById;
      const responses = await Promise.all(ids.map((id) => getById(id)));
      setProfiles(Object.fromEntries(ids.map((id, i) => [id, responses[i]?.data])));
      setIsLoading(false);
    };
    load();
  }, [ids]);

  return (
    <Modal isOpen={open} toggle={onClose} centered style={{ maxWidth: "520px" }}>
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: "18px", fontWeight: "700", textTransform: "uppercase" }}>
          {ids.length === 1 ? `${label} already exists` : `${count(ids.length)} already exist`}
        </span>
      </ModalHeader>
      <ModalBody>
        {createdCount > 0 && (
          <div className="d-flex align-items-center gap-2 mb-3" style={{ color: "#16803C", fontSize: "14px" }}>
            <CheckCircle size={16} />
            {count(createdCount)} added successfully.
          </div>
        )}
        <p className="mb-3" style={{ fontSize: "14px" }}>
          {ids.length === 1
            ? `This ${type} is already on Hyperscout, so it wasn't added again.`
            : `These ${type}s are already on Hyperscout, so they weren't added again.`}
        </p>
        {ids.map((id) => (
          <div key={id} className="d-flex align-items-center justify-content-between gap-3 p-3 mb-2 border rounded">
            <div style={{ minWidth: 0 }}>
              {isLoading ? (
                <Spinner size="sm" color="secondary" />
              ) : (
                <>
                  <div className="text-truncate" style={{ fontWeight: 600 }}>
                    {profiles[id]?.name || `${label} #${id}`}
                  </div>
                  {profiles[id]?.website && (
                    <div className="text-truncate" style={{ fontSize: "13px", color: "#6B7280" }}>
                      {profiles[id].website}
                    </div>
                  )}
                </>
              )}
            </div>
            <Link
              target="_blank"
              to={`/profile/${id}/${type}`}
              className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1 flex-shrink-0"
            >
              View profile
              <ExternalLink size={14} />
            </Link>
          </div>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapDispatchToProps = {
  getBrandById: getBrandByIdAction,
  getRetailerById: getRetailerByIdAction,
};

export default connect(null, mapDispatchToProps)(ExistingProfilesModal);
